var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuEdges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0H4V48H52V0Z",
    fill: "url(#paint0_linear_8046_6445)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7163 11.716C38.1087 11.7713 38.4256 11.8733 38.7309 12.0453C39.3675 12.4095 39.6728 12.9049 39.8094 13.8025C39.8443 14.0473 39.917 15.143 39.9373 15.755C39.9926 17.3694 40.0216 26.6247 39.9809 29.3932C39.9548 31.2349 39.9257 31.8323 39.8385 32.2491C39.5507 33.6245 38.7396 34.6299 37.3965 35.2769C36.7308 35.5945 36.1144 35.781 35.6813 35.7868C35.0795 35.7956 34.9923 35.6353 34.7307 34.0879C34.5708 33.135 34.5591 33.2136 34.9022 33.1554C35.1929 33.1087 36.0301 32.8173 36.2365 32.6949C36.7308 32.3977 37.0593 31.8702 37.161 31.197C37.1872 31.0368 37.193 28.8278 37.1872 22.6615L37.1786 14.4676C37.1785 14.3922 37.1306 14.3252 37.0593 14.3008C36.9459 14.26 36.9343 14.2629 36.5796 14.3999C36.2831 14.5165 33.0445 16.1571 30.0269 17.722C28.2245 18.6545 26.0994 19.7415 25.8959 19.8289C25.4656 20.0184 25.2331 20.0125 24.954 19.8085C24.8261 19.7182 24.7563 19.6191 24.4278 19.0684C24.2185 18.7187 24.0295 18.3777 24.0063 18.3136C23.8929 17.9901 24.0121 17.6725 24.3609 17.3752C24.5557 17.2091 24.8028 17.078 27.082 15.9356C29.8787 14.5339 33.53 12.7534 34.3295 12.3979C35.7307 11.7742 36.6988 11.5819 37.7163 11.716ZM21.009 11.9782C21.1573 12.0394 21.2125 12.1647 21.1922 12.3862C21.1834 12.4853 21.1689 12.9049 21.1602 13.3217C21.1515 13.7384 21.1369 14.1347 21.1282 14.2017C21.1199 14.2732 21.0594 14.327 20.9875 14.327H20.9043C20.1136 14.3299 19.349 14.9973 18.9798 16.0172C18.8112 16.4893 18.7967 16.6205 18.692 18.8294C18.5321 22.1486 18.5176 22.714 18.5176 25.1677C18.5176 27.6243 18.5467 28.4781 18.692 30.3549C18.7909 31.675 18.849 31.9402 19.163 32.5055C19.3432 32.829 19.5351 33.0417 19.7444 33.1437C19.8927 33.2166 19.9392 33.2253 20.1863 33.2224C20.416 33.2195 20.5003 33.202 20.695 33.1291C20.8229 33.0825 20.9857 33.0097 21.0584 32.9689C21.5672 32.6833 29.4368 28.7346 30.5386 28.21C31.1985 27.8982 31.4485 27.8487 31.809 27.9594C32.1142 28.0556 32.2509 28.1751 32.6608 28.7084C32.8875 29.0056 33.0213 29.2591 33.0445 29.4486C33.0794 29.74 32.8904 30.0868 32.5765 30.3024C32.4166 30.4131 25.3464 33.9538 24.6051 34.2948C23.8929 34.6241 23.6429 34.7523 23.0789 35.0787C22.0701 35.6644 21.2881 35.8917 20.288 35.8917C19.0496 35.8917 18.1455 35.5216 17.3344 34.6853C17.0466 34.388 16.8082 34.0413 16.6076 33.6333C16.3925 33.1903 16.2878 32.8698 16.1774 32.3219C15.9942 31.4185 16 31.6633 16 23.798C16 19.3365 16.0116 16.533 16.0291 16.3524C16.1134 15.4723 16.3431 14.7234 16.721 14.0939C17.4536 12.8787 18.6223 12.1152 20.0293 11.9374C20.3142 11.9025 20.884 11.9258 21.009 11.9782ZM33.53 19.7765C33.7306 19.8785 33.8382 20.0242 33.969 20.3652C34.0359 20.54 34.1812 20.8343 34.2917 21.0179C34.6493 21.6212 34.658 21.9126 34.3207 22.1632C34.2481 22.2186 33.5329 22.5857 32.7335 22.9821C31.9311 23.3784 29.5502 24.5674 27.4396 25.6252C25.329 26.683 23.512 27.5835 23.3987 27.6301C23.0702 27.7613 22.8027 27.738 22.5178 27.5485C22.3957 27.4669 21.8899 26.7705 21.7387 26.479C21.634 26.2809 21.6253 26.2401 21.6282 26.0419C21.6282 25.8554 21.6428 25.7971 21.7213 25.6485C21.8404 25.4183 21.9655 25.2842 22.1806 25.1473C22.4742 24.9579 32.8323 19.7794 33.0067 19.7328C33.1928 19.6832 33.3817 19.7007 33.53 19.7765Z",
    fill: "url(#paint1_linear_8046_6445)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 5.58472C34.3957 9.43971 34.7133 9.43971 33.3563 9.43971C31.9992 9.43971 32.3176 9.43971 32.3176 5.58472C32.3176 1.72974 32.0303 1.72974 33.357 1.72974C34.6822 1.72974 34.3957 1.72974 34.3957 5.58472Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 5.58472C34.3957 9.43971 34.7133 9.43971 33.3563 9.43971C31.9992 9.43971 32.3176 9.43971 32.3176 5.58472C32.3176 1.72974 32.0303 1.72974 33.357 1.72974C34.6822 1.72974 34.3957 1.72974 34.3957 5.58472Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 5.58472C34.3957 9.43971 34.7133 9.43971 33.3563 9.43971C31.9992 9.43971 32.3176 9.43971 32.3176 5.58472C32.3176 1.72974 32.0303 1.72974 33.357 1.72974C34.6822 1.72974 34.3957 1.72974 34.3957 5.58472Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 5.58472C34.3957 9.43971 34.7133 9.43971 33.3563 9.43971C31.9992 9.43971 32.3176 9.43971 32.3176 5.58472C32.3176 1.72974 32.0303 1.72974 33.357 1.72974C34.6822 1.72974 34.3957 1.72974 34.3957 5.58472Z",
    fill: "url(#paint2_linear_8046_6445)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2533 5.58472C29.2533 9.43971 29.5708 9.43971 28.2139 9.43971C26.8567 9.43971 27.1751 9.43971 27.1751 5.58472C27.1751 1.72974 26.8878 1.72974 28.2145 1.72974C29.5397 1.72974 29.2533 1.72974 29.2533 5.58472Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2533 5.58472C29.2533 9.43971 29.5708 9.43971 28.2139 9.43971C26.8567 9.43971 27.1751 9.43971 27.1751 5.58472C27.1751 1.72974 26.8878 1.72974 28.2145 1.72974C29.5397 1.72974 29.2533 1.72974 29.2533 5.58472Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2533 5.58472C29.2533 9.43971 29.5708 9.43971 28.2139 9.43971C26.8567 9.43971 27.1751 9.43971 27.1751 5.58472C27.1751 1.72974 26.8878 1.72974 28.2145 1.72974C29.5397 1.72974 29.2533 1.72974 29.2533 5.58472Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2533 5.58472C29.2533 9.43971 29.5708 9.43971 28.2139 9.43971C26.8567 9.43971 27.1751 9.43971 27.1751 5.58472C27.1751 1.72974 26.8878 1.72974 28.2145 1.72974C29.5397 1.72974 29.2533 1.72974 29.2533 5.58472Z",
    fill: "url(#paint3_linear_8046_6445)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 5.58472C24.1106 9.43971 24.4281 9.43971 23.0712 9.43971C21.714 9.43971 22.0325 9.43971 22.0325 5.58472C22.0325 1.72974 21.7451 1.72974 23.0718 1.72974C24.397 1.72974 24.1106 1.72974 24.1106 5.58472Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 5.58472C24.1106 9.43971 24.4281 9.43971 23.0712 9.43971C21.714 9.43971 22.0325 9.43971 22.0325 5.58472C22.0325 1.72974 21.7451 1.72974 23.0718 1.72974C24.397 1.72974 24.1106 1.72974 24.1106 5.58472Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 5.58472C24.1106 9.43971 24.4281 9.43971 23.0712 9.43971C21.714 9.43971 22.0325 9.43971 22.0325 5.58472C22.0325 1.72974 21.7451 1.72974 23.0718 1.72974C24.397 1.72974 24.1106 1.72974 24.1106 5.58472Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 5.58472C24.1106 9.43971 24.4281 9.43971 23.0712 9.43971C21.714 9.43971 22.0325 9.43971 22.0325 5.58472C22.0325 1.72974 21.7451 1.72974 23.0718 1.72974C24.397 1.72974 24.1106 1.72974 24.1106 5.58472Z",
    fill: "url(#paint4_linear_8046_6445)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 41.4766C34.3957 45.3316 34.7133 45.3316 33.3563 45.3316C31.9992 45.3316 32.3176 45.3316 32.3176 41.4766C32.3176 37.6216 32.0303 37.6216 33.357 37.6216C34.6822 37.6216 34.3957 37.6216 34.3957 41.4766Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 41.4766C34.3957 45.3316 34.7133 45.3316 33.3563 45.3316C31.9992 45.3316 32.3176 45.3316 32.3176 41.4766C32.3176 37.6216 32.0303 37.6216 33.357 37.6216C34.6822 37.6216 34.3957 37.6216 34.3957 41.4766Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 41.4766C34.3957 45.3316 34.7133 45.3316 33.3563 45.3316C31.9992 45.3316 32.3176 45.3316 32.3176 41.4766C32.3176 37.6216 32.0303 37.6216 33.357 37.6216C34.6822 37.6216 34.3957 37.6216 34.3957 41.4766Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 41.4766C34.3957 45.3316 34.7133 45.3316 33.3563 45.3316C31.9992 45.3316 32.3176 45.3316 32.3176 41.4766C32.3176 37.6216 32.0303 37.6216 33.357 37.6216C34.6822 37.6216 34.3957 37.6216 34.3957 41.4766Z",
    fill: "url(#paint5_linear_8046_6445)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2533 41.4766C29.2533 45.3316 29.5708 45.3316 28.2139 45.3316C26.8567 45.3316 27.1751 45.3316 27.1751 41.4766C27.1751 37.6216 26.8878 37.6216 28.2145 37.6216C29.5397 37.6216 29.2533 37.6216 29.2533 41.4766Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2533 41.4766C29.2533 45.3316 29.5708 45.3316 28.2139 45.3316C26.8567 45.3316 27.1751 45.3316 27.1751 41.4766C27.1751 37.6216 26.8878 37.6216 28.2145 37.6216C29.5397 37.6216 29.2533 37.6216 29.2533 41.4766Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2533 41.4766C29.2533 45.3316 29.5708 45.3316 28.2139 45.3316C26.8567 45.3316 27.1751 45.3316 27.1751 41.4766C27.1751 37.6216 26.8878 37.6216 28.2145 37.6216C29.5397 37.6216 29.2533 37.6216 29.2533 41.4766Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2533 41.4766C29.2533 45.3316 29.5708 45.3316 28.2139 45.3316C26.8567 45.3316 27.1751 45.3316 27.1751 41.4766C27.1751 37.6216 26.8878 37.6216 28.2145 37.6216C29.5397 37.6216 29.2533 37.6216 29.2533 41.4766Z",
    fill: "url(#paint6_linear_8046_6445)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 41.4766C24.1106 45.3316 24.4281 45.3316 23.0712 45.3316C21.714 45.3316 22.0325 45.3316 22.0325 41.4766C22.0325 37.6216 21.7451 37.6216 23.0718 37.6216C24.397 37.6216 24.1106 37.6216 24.1106 41.4766Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 41.4766C24.1106 45.3316 24.4281 45.3316 23.0712 45.3316C21.714 45.3316 22.0325 45.3316 22.0325 41.4766C22.0325 37.6216 21.7451 37.6216 23.0718 37.6216C24.397 37.6216 24.1106 37.6216 24.1106 41.4766Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 41.4766C24.1106 45.3316 24.4281 45.3316 23.0712 45.3316C21.714 45.3316 22.0325 45.3316 22.0325 41.4766C22.0325 37.6216 21.7451 37.6216 23.0718 37.6216C24.397 37.6216 24.1106 37.6216 24.1106 41.4766Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 41.4766C24.1106 45.3316 24.4281 45.3316 23.0712 45.3316C21.714 45.3316 22.0325 45.3316 22.0325 41.4766C22.0325 37.6216 21.7451 37.6216 23.0718 37.6216C24.397 37.6216 24.1106 37.6216 24.1106 41.4766Z",
    fill: "url(#paint7_linear_8046_6445)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 17.7623C13.4239 17.7623 13.4239 17.442 13.4239 18.8111C13.4239 20.1805 13.4239 19.8592 9.56887 19.8592C5.71387 19.8592 5.71387 20.1491 5.71387 18.8104C5.71387 17.4733 5.71387 17.7623 9.56887 17.7623Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 17.7623C13.4239 17.7623 13.4239 17.442 13.4239 18.8111C13.4239 20.1805 13.4239 19.8592 9.56887 19.8592C5.71387 19.8592 5.71387 20.1491 5.71387 18.8104C5.71387 17.4733 5.71387 17.7623 9.56887 17.7623Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 17.7623C13.4239 17.7623 13.4239 17.442 13.4239 18.8111C13.4239 20.1805 13.4239 19.8592 9.56887 19.8592C5.71387 19.8592 5.71387 20.1491 5.71387 18.8104C5.71387 17.4733 5.71387 17.7623 9.56887 17.7623Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 17.7623C13.4239 17.7623 13.4239 17.442 13.4239 18.8111C13.4239 20.1805 13.4239 19.8592 9.56887 19.8592C5.71387 19.8592 5.71387 20.1491 5.71387 18.8104C5.71387 17.4733 5.71387 17.7623 9.56887 17.7623Z",
    fill: "url(#paint8_linear_8046_6445)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 22.9515C13.4239 22.9515 13.4239 22.6311 13.4239 24.0002C13.4239 25.3696 13.4239 25.0483 9.56887 25.0483C5.71387 25.0483 5.71387 25.3382 5.71387 23.9995C5.71387 22.6625 5.71387 22.9515 9.56887 22.9515Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 22.9515C13.4239 22.9515 13.4239 22.6311 13.4239 24.0002C13.4239 25.3696 13.4239 25.0483 9.56887 25.0483C5.71387 25.0483 5.71387 25.3382 5.71387 23.9995C5.71387 22.6625 5.71387 22.9515 9.56887 22.9515Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 22.9515C13.4239 22.9515 13.4239 22.6311 13.4239 24.0002C13.4239 25.3696 13.4239 25.0483 9.56887 25.0483C5.71387 25.0483 5.71387 25.3382 5.71387 23.9995C5.71387 22.6625 5.71387 22.9515 9.56887 22.9515Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 22.9515C13.4239 22.9515 13.4239 22.6311 13.4239 24.0002C13.4239 25.3696 13.4239 25.0483 9.56887 25.0483C5.71387 25.0483 5.71387 25.3382 5.71387 23.9995C5.71387 22.6625 5.71387 22.9515 9.56887 22.9515Z",
    fill: "url(#paint9_linear_8046_6445)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 28.1407C13.4239 28.1407 13.4239 27.8203 13.4239 29.1894C13.4239 30.5588 13.4239 30.2375 9.56887 30.2375C5.71387 30.2375 5.71387 30.5275 5.71387 29.1888C5.71387 27.8517 5.71387 28.1407 9.56887 28.1407Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 28.1407C13.4239 28.1407 13.4239 27.8203 13.4239 29.1894C13.4239 30.5588 13.4239 30.2375 9.56887 30.2375C5.71387 30.2375 5.71387 30.5275 5.71387 29.1888C5.71387 27.8517 5.71387 28.1407 9.56887 28.1407Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 28.1407C13.4239 28.1407 13.4239 27.8203 13.4239 29.1894C13.4239 30.5588 13.4239 30.2375 9.56887 30.2375C5.71387 30.2375 5.71387 30.5275 5.71387 29.1888C5.71387 27.8517 5.71387 28.1407 9.56887 28.1407Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 28.1407C13.4239 28.1407 13.4239 27.8203 13.4239 29.1894C13.4239 30.5588 13.4239 30.2375 9.56887 30.2375C5.71387 30.2375 5.71387 30.5275 5.71387 29.1888C5.71387 27.8517 5.71387 28.1407 9.56887 28.1407Z",
    fill: "url(#paint10_linear_8046_6445)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 17.7625C50 17.7625 50 17.4421 50 18.8112C50 20.1806 50 19.8593 46.1431 19.8593C42.2861 19.8593 42.2861 20.1493 42.2861 18.8106C42.2861 17.4735 42.2861 17.7625 46.1431 17.7625Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 17.7625C50 17.7625 50 17.4421 50 18.8112C50 20.1806 50 19.8593 46.1431 19.8593C42.2861 19.8593 42.2861 20.1493 42.2861 18.8106C42.2861 17.4735 42.2861 17.7625 46.1431 17.7625Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 17.7625C50 17.7625 50 17.4421 50 18.8112C50 20.1806 50 19.8593 46.1431 19.8593C42.2861 19.8593 42.2861 20.1493 42.2861 18.8106C42.2861 17.4735 42.2861 17.7625 46.1431 17.7625Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 17.7625C50 17.7625 50 17.4421 50 18.8112C50 20.1806 50 19.8593 46.1431 19.8593C42.2861 19.8593 42.2861 20.1493 42.2861 18.8106C42.2861 17.4735 42.2861 17.7625 46.1431 17.7625Z",
    fill: "url(#paint11_linear_8046_6445)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 22.9515C50 22.9515 50 22.6311 50 24.0002C50 25.3696 50 25.0483 46.1431 25.0483C42.2861 25.0483 42.2861 25.3382 42.2861 23.9995C42.2861 22.6625 42.2861 22.9515 46.1431 22.9515Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 22.9515C50 22.9515 50 22.6311 50 24.0002C50 25.3696 50 25.0483 46.1431 25.0483C42.2861 25.0483 42.2861 25.3382 42.2861 23.9995C42.2861 22.6625 42.2861 22.9515 46.1431 22.9515Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 22.9515C50 22.9515 50 22.6311 50 24.0002C50 25.3696 50 25.0483 46.1431 25.0483C42.2861 25.0483 42.2861 25.3382 42.2861 23.9995C42.2861 22.6625 42.2861 22.9515 46.1431 22.9515Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 22.9515C50 22.9515 50 22.6311 50 24.0002C50 25.3696 50 25.0483 46.1431 25.0483C42.2861 25.0483 42.2861 25.3382 42.2861 23.9995C42.2861 22.6625 42.2861 22.9515 46.1431 22.9515Z",
    fill: "url(#paint12_linear_8046_6445)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 28.1407C50 28.1407 50 27.8203 50 29.1894C50 30.5588 50 30.2375 46.1431 30.2375C42.2861 30.2375 42.2861 30.5275 42.2861 29.1888C42.2861 27.8517 42.2861 28.1407 46.1431 28.1407Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 28.1407C50 28.1407 50 27.8203 50 29.1894C50 30.5588 50 30.2375 46.1431 30.2375C42.2861 30.2375 42.2861 30.5275 42.2861 29.1888C42.2861 27.8517 42.2861 28.1407 46.1431 28.1407Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 28.1407C50 28.1407 50 27.8203 50 29.1894C50 30.5588 50 30.2375 46.1431 30.2375C42.2861 30.2375 42.2861 30.5275 42.2861 29.1888C42.2861 27.8517 42.2861 28.1407 46.1431 28.1407Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 28.1407C50 28.1407 50 27.8203 50 29.1894C50 30.5588 50 30.2375 46.1431 30.2375C42.2861 30.2375 42.2861 30.5275 42.2861 29.1888C42.2861 27.8517 42.2861 28.1407 46.1431 28.1407Z",
    fill: "url(#paint13_linear_8046_6445)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8046_6445",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8046_6445",
    x1: 28,
    y1: 11.6755,
    x2: 28,
    y2: 35.8917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8046_6445",
    x1: 33.3566,
    y1: 1.72974,
    x2: 33.3566,
    y2: 9.43971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8046_6445",
    x1: 28.214,
    y1: 1.72974,
    x2: 28.214,
    y2: 9.43971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8046_6445",
    x1: 23.0714,
    y1: 1.72974,
    x2: 23.0714,
    y2: 9.43971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8046_6445",
    x1: 33.3566,
    y1: 37.6216,
    x2: 33.3566,
    y2: 45.3316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8046_6445",
    x1: 28.214,
    y1: 37.6216,
    x2: 28.214,
    y2: 45.3316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8046_6445",
    x1: 23.0714,
    y1: 37.6216,
    x2: 23.0714,
    y2: 45.3316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8046_6445",
    x1: 9.56888,
    y1: 17.7297,
    x2: 9.56888,
    y2: 19.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8046_6445",
    x1: 9.56888,
    y1: 22.9189,
    x2: 9.56888,
    y2: 25.0811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8046_6445",
    x1: 9.56888,
    y1: 28.1082,
    x2: 9.56888,
    y2: 30.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8046_6445",
    x1: 46.1431,
    y1: 17.73,
    x2: 46.1431,
    y2: 19.8921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8046_6445",
    x1: 46.1431,
    y1: 22.9189,
    x2: 46.1431,
    y2: 25.0811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8046_6445",
    x1: 46.1431,
    y1: 28.1082,
    x2: 46.1431,
    y2: 30.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEdges);
export default __webpack_public_path__ + "static/media/Menu-Edges.9a109d10f1bb3f5e98020754dd21f541.svg";
export { ForwardRef as ReactComponent };